// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__26w48","title":"Header_title__1n3wf","side":"Header_side__3Xhk_"};